import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Prediction} from '../../models/Prediction';
import * as tf from '@tensorflow/tfjs';
import {FaceRecognitionService} from '../face-recognition/face-recognition.service';

@Injectable({
  providedIn: 'root'
})
export class EmotionService {
  public isBusyUpload?: boolean;
  EMOTION_MODE_OFF = 0;
  EMOTION_MODE_ON = 1;
  EMOTION_MODE_ON_2 = 2;
  EMOTION_MODE_ON_3 = 3;
  /* EMOTION_MODE_ON_4 = 4 ;*/
  public emotionMode: number;

  public uploadLocalPhotoSumResTimes = 0;
  public uploadLocalPhotoCounter = 0;
  public isBusyUploadLocalPhoto?: boolean;

  public onPredictionChart: any;
  public onPredictionRadarChart: any;

  public emotionalLocalMsg0?: string;
  public emotionalLocalMsgAngry?: string;
  public emotionalLocalMsgDisgust?: string;
  public emotionalLocalMsgFear?: string;
  public emotionalLocalMsgHappy?: string;
  public emotionalLocalMsgNeutral?: string;
  public emotionalLocalMsgSad?: string;
  public emotionalLocalMsgSurprise?: string;
  public emotionalLocalMsgContemptuous?: string;
  public emotionalLocalMsg9?: string;
  public emotionalLocalMsg10?: string;

  public emotionMaxIcon?: string;
  public emotionMaxText?: string;
  model: any;

  constructor(private http: HttpClient, private faceRecognitionService: FaceRecognitionService) {
    this.emotionMode = this.EMOTION_MODE_OFF;

    //  this.loadModel(null);

    this.faceRecognitionService.onLoadedClassifiers = () => {
      this.startVideoDetection();
    };
  }

  localVideoElement: any;
  canvasLocalOutput?: HTMLCanvasElement;
  canvasPreview?: HTMLCanvasElement;

  setVariables(localVideoElement: any, canvasLocal: any) {
    this.localVideoElement = localVideoElement;
    this.canvasLocalOutput = canvasLocal;
    // this.predict(canvasLocal);
  }

  /* Start Analysis */
  async loadModel(onSuccess: any = null) {
    this.model = await tf.loadLayersModel('assets/tensorFlow/model.json');
    if (onSuccess) {
      onSuccess();
    }
  }

  async predict(canvas: any, onSuccess: any = null) {
    const ctx = canvas.getContext('2d');
    await tf.tidy(() => {
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let img = tf.browser.fromPixels(imageData, 1);
      // tf.print(img);
      img = img.expandDims(0);
      const temp = img.toFloat().div(tf.scalar(255));
      const output = this.model.predict(temp) as any;
      const predictions: any = Array.from(output.dataSync());
      if (onSuccess) {
        onSuccess(this.getPredictionObject(predictions));
      }
    });
  }

  getPredictionObject(predictions: any) {
    return new Prediction(Prediction.FROM_CNN_TYPE, predictions);
  }

  initPredict(canvas: any) {
    this.predict(canvas);
  }

  setPreview(canvasPreview: any) {
    this.canvasPreview = canvasPreview;
  }

  startVideoDetection() {
    this.clearEmotionalAll();
    this.faceRecognitionService.stopVideoDetection();
    this.faceRecognitionService.videoDetection(this.localVideoElement, this.canvasLocalOutput, this.canvasPreview, (canvas: any) => {
      if (this.faceRecognitionService.emotionServiceUrl === FaceRecognitionService.LOCALLY_CNN) {
        this.predictLocally(canvas);
      } else {
        this.uploadLocalPhoto(canvas);
      }
    });
    this.emotionalLocalMsg0 = '';

    /*  this.showEmotionalRemoteMessage('Remote Started');
      this.showEmotionalLocalMessage('Local Started');*/
  }

  private predictLocally(canvas: any) {
    const startTime = new Date().getTime();
    this.predict(canvas, (prediction: any) => {
      if (this.faceRecognitionService.started) {
        this.loadEmotionalLocalMessages(startTime, prediction);
      } else {
        this.showEmotionalLocalMessage('');
      }
    });
  }

  stopVideoDetection() {
    this.emotionalLocalMsg0 = '';
    this.showEmotionalLocalMessage('');
    this.faceRecognitionService.stopVideoDetection();
  }

  enableEmotionModeOn() {
    this.startVideoDetection();
    this.clearStatistics();
  }

  changeEmotionMode() {
    if (++this.emotionMode === 2) {
      this.emotionMode = 0; // this.EMOTION_MODE_OFF
    }
    switch (this.emotionMode) {
      case this.EMOTION_MODE_OFF:
        this.stopVideoDetection();
        break;
      case this.EMOTION_MODE_ON:
        this.enableEmotionModeOn();
        break;
      /*case this.EMOTION_MODE_ON_2:
        this.clearStatistics();
        break;
      case this.EMOTION_MODE_ON_3:
        this.clearStatistics();
        break;*/
    }
  }

  showEmotionalLocalMessage(msg: string) {
    this.emotionalLocalMsgAngry = '';
    this.emotionalLocalMsgDisgust = '';
    this.emotionalLocalMsgFear = '';
    this.emotionalLocalMsgHappy = '';
    this.emotionalLocalMsgNeutral = '';
    this.emotionalLocalMsgSad = '';
    this.emotionalLocalMsgSurprise = '';
    this.emotionalLocalMsgContemptuous = '';
    this.emotionalLocalMsg9 = '';
    this.emotionalLocalMsg10 = '';
    this.emotionalLocalMsg0 = msg;
    this.emotionMaxIcon = '';
    this.emotionMaxText = '';
  }

  clearEmotionalAll() {
    this.showEmotionalLocalMessage('');
    this.clearStatistics();
  }

  clearStatistics() {
    this.uploadLocalPhotoSumResTimes = 0;
    this.uploadLocalPhotoCounter = 0;
  }

  updateBigVideo(v: any, c: any, w: any, h: any): any {
    if (v.paused || v.ended) {
      return false;
    }
    c.drawImage(v, 0, 0, w, h);
    setTimeout(this.updateBigVideo, 20, v, c, w, h);
  }

  loadEmotionalLocalMessages(startTime: any, prediction: Prediction) {
    const nowTime = Date.now();
    const responseTime = nowTime - startTime;
    this.uploadLocalPhotoCounter++;
    this.uploadLocalPhotoSumResTimes += responseTime;
    this.emotionalLocalMsgAngry = prediction.getAngryMsg();
    this.emotionalLocalMsgDisgust = prediction.getDisgustMsg();
    this.emotionalLocalMsgFear = prediction.getFearMsg();
    this.emotionalLocalMsgHappy = prediction.getHappyMsg();
    this.emotionalLocalMsgNeutral = prediction.getNeutralMsg();
    this.emotionalLocalMsgSad = prediction.getSadMsg();
    this.emotionalLocalMsgSurprise = prediction.getSurpriseMsg();
    this.emotionalLocalMsgContemptuous = prediction.getContemptuousMsg();
    this.emotionalLocalMsg9 = Math.round(responseTime) + ' ms (res. time)';
    this.emotionalLocalMsg10 = Math.round(this.uploadLocalPhotoSumResTimes / this.uploadLocalPhotoCounter) + ' ms (average)';
    this.emotionalLocalMsg0 = '';
    const maxEmotion: any = prediction.getMaxEmotionIcon();
    this.emotionMaxIcon = maxEmotion.icon;
    this.emotionMaxText = maxEmotion.text;
    if (this.onPredictionChart) {
      this.onPredictionChart(prediction);
    }
    if (this.onPredictionRadarChart) {
      this.onPredictionRadarChart(prediction);
    }
  }

  uploadLocalPhoto(canvas: any) {
    if (!this.isBusyUploadLocalPhoto) {
      // const data = canvas.toDataURL('image/png');
      const startTime = new Date().getTime();
      // const blob: Blob = this.dataURItoBlob(data);
      canvas.toBlob((blob: Blob | null) => {
        const fd: FormData = new FormData();
        if (blob) {
          const file: File = new File([blob], startTime.toString() + '.png');
          fd.append('file', file);

          this.isBusyUploadLocalPhoto = true;
          const lastUrl = this.faceRecognitionService.emotionServiceUrl;
          this.uploadPhoto(this.faceRecognitionService.emotionServiceUrl, fd, (pred: Prediction) => {
            this.isBusyUploadLocalPhoto = false;
            if (this.faceRecognitionService.started) {
              const prediction = new Prediction(Prediction.FROM_SERVICE_TYPE, pred);
              this.loadEmotionalLocalMessages(startTime, prediction);
            } else {
              this.showEmotionalLocalMessage('');
            }
            if (this.faceRecognitionService.emotionServiceUrl !== lastUrl) {
              this.clearStatistics();
            }
          }, () => {
            this.isBusyUploadLocalPhoto = false;
            if (this.faceRecognitionService.started) {
              const nowTime = new Date().getTime();
              const responseTime = nowTime - startTime;
              this.uploadLocalPhotoCounter++;
              this.uploadLocalPhotoSumResTimes += responseTime;
              this.showEmotionalLocalMessage('No prediction');
              if (this.onPredictionRadarChart) {
                this.onPredictionRadarChart(null);
              }
              //                                                   '     Surprise = '
              this.emotionalLocalMsg9 = Math.round(responseTime) + ' ms (res. time)';
              this.emotionalLocalMsg10 = Math.round(this.uploadLocalPhotoSumResTimes / this.uploadLocalPhotoCounter) + ' ms (average)';
            } else {
              this.showEmotionalLocalMessage('');
            }
            if (this.faceRecognitionService.emotionServiceUrl !== lastUrl) {
              this.clearStatistics();
            }
          });
        }
      }, 'image/jpg');
    }
  }

  public async uploadPhoto(path: string, fd: FormData, onSuccess: any = null, onError: any = null) {
    this.isBusyUpload = true;
    return this.http.post(path, fd)
      .subscribe((data: any) => {
        console.log(data);
        if (data.status === 0) {
          console.log('Upload photo successfully');
          if (onSuccess) {
            onSuccess(data.prediction);
          }
        } else {
          if (onError) {
            onError();
          }
          console.log(data.message);
        }
        this.isBusyUpload = false;
      }, err => {
        console.log(err);
        this.isBusyUpload = false;
        if (onError) {
          onError();
        }
      });
  }

  dataURItoBlob(dataURI: string) {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/jpg'
    });
  }
}
